<div class="location-palette-container">
    <div class="d-flex gap-2 mt-2">
        <button class="btn btn-danger" (click)="finishDrawingFromButton()">
            <span><i class="fa-solid fa-check"></i></span>
            <br>
            Done
        </button>
        <button class="btn btn-secondary" (click)="cancelDrawing()">
            <span><i class="fa-solid fa-xmark"></i></span>
            <br>
            Cancel
        </button>
    </div>
    <div class='help-text'>
        Click anywhere on the globe to add points. Double tap a point or click the <strong class="text-white">Done</strong> button to
        finish drawing.
    </div>
</div>